import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { CaretDown } from 'phosphor-react'

import { useIntl } from 'react-intl'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { scrollToComponent } from '../../landing'

type NavigationProps = {
  variant: 'mobile' | 'desktop'
  setIsMobileMenuOpen?: (value: boolean) => void
}

export const Navigation = ({ variant = 'mobile', setIsMobileMenuOpen }: NavigationProps) => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  if (variant === 'desktop') {
    return (
      <nav className="hidden font-semibold text-white uppercase lg:flex gap-14 font-openSans">
        <button
          className="uppercase"
          onClick={() => {
            pathname !== '/' && navigate('/')
            setTimeout(() => {
              scrollToComponent('about-us')
            }, 100)
          }}
        >
          {formatMessage({ id: 'ABOUT_US' })}
        </button>
        <button
          className="uppercase"
          onClick={() => {
            pathname !== '/' && navigate('/')
            setTimeout(() => {
              scrollToComponent('why-us')
            }, 100)
          }}
        >
          {formatMessage({ id: 'WHY_US' })}
        </button>
        <button
          className="uppercase"
          onClick={() => {
            pathname !== '/' && navigate('/')
            setTimeout(() => {
              scrollToComponent('become-an-expert')
            }, 100)
          }}
        >
          {formatMessage({ id: 'EXPERT' })}
        </button>
        <button
          className="uppercase"
          onClick={() => {
            pathname !== '/' && navigate('/')
            setTimeout(() => {
              scrollToComponent('become-a-client')
            }, 100)
          }}
        >
          {formatMessage({ id: 'CLIENT' })}
        </button>
        <DropdownMenu.Root modal={false}>
          <DropdownMenu.Trigger asChild>
            <button
              type="button"
              className="flex items-center gap-1 font-semibold uppercase outline-none"
            >
              {formatMessage({ id: 'COMPLIANCE' })}
              <CaretDown />
            </button>
          </DropdownMenu.Trigger>
          <DropdownMenu.Portal>
            <DropdownMenu.Content className="flex flex-col overflow-hidden pt-[30px] bg-[#001D2F] rounded-b-lg font-semibold text-white overflow">
              <Link
                className="block py-2 px-2.5 font-semibold text-white hover:bg-[#4A7D9A]"
                to="/privacy-policy"
              >
                {formatMessage({ id: 'PRIVACY_POLICY' })}
              </Link>
              <Link
                className="block py-2 px-2.5 font-semibold text-white hover:bg-[#4A7D9A]"
                to="/terms-of-use"
              >
                {formatMessage({ id: 'TERMS_OF_USE' })}
              </Link>
              <Link
                className="block py-2 px-2.5 font-semibold text-white hover:bg-[#4A7D9A]"
                to="/terms-of-participation"
              >
                {formatMessage({ id: 'TERMS_OF_PARTICIPATION' })}
              </Link>
            </DropdownMenu.Content>
          </DropdownMenu.Portal>
        </DropdownMenu.Root>
      </nav>
    )
  }

  return (
    <nav className="flex flex-col items-start h-full gap-10 font-semibold text-white uppercase font-openSans">
      <button className="uppercase" onClick={() => {
        pathname !== '/' && navigate('/')
        setIsMobileMenuOpen && setIsMobileMenuOpen(false)
        setTimeout(() => {
          scrollToComponent('about-us')
        }, 100)
      }}>{formatMessage({ id: 'ABOUT_US' })}</button>
      <button className="uppercase" onClick={() => {
        pathname !== '/' && navigate('/')
        setIsMobileMenuOpen && setIsMobileMenuOpen(false)
        setTimeout(() => {
          scrollToComponent('why-us')
        }, 100)
      }}>{formatMessage({ id: 'WHY_US' })}</button>
      <button className="uppercase" onClick={() => {
        pathname !== '/' && navigate('/')
        setIsMobileMenuOpen && setIsMobileMenuOpen(false)
        setTimeout(() => {
          scrollToComponent('become-an-expert')
        }, 100)
      }}>{formatMessage({ id: 'EXPERT' })}</button>
      <button className="uppercase" onClick={() => {
        pathname !== '/' && navigate('/')
        setIsMobileMenuOpen && setIsMobileMenuOpen(false)
        setTimeout(() => {
          scrollToComponent('become-a-client')
        }, 100)
      }}>{formatMessage({ id: 'CLIENT' })}</button>
      <Link to="/privacy-policy">{formatMessage({ id: 'PRIVACY_POLICY' })}</Link>
      <Link to="/terms-of-use">{formatMessage({ id: 'TERMS_OF_USE' })}</Link>
      <Link to="/terms-of-participation">{formatMessage({ id: 'TERMS_OF_PARTICIPATION' })}</Link>
    </nav>
  )
}
